import React from 'react';
import PageHeader from '../../components/PageHeader';
import './IndustryDetail.css';

interface Feature {
  tag: string;
  title: string;
  desc: string;
}

interface IndustryDetailProps {
  breadcrumb: string;
  title: string;
  subtitle: string;
  description: string;
  features: Feature[];
  accentColor?: string;
}

const IndustryDetail: React.FC<IndustryDetailProps> = ({
  breadcrumb,
  title,
  subtitle,
  description,
  features,
  accentColor = '#2563eb',
}) => {
  return (
    <>
      <PageHeader breadcrumb={breadcrumb} title={title} subtitle={subtitle} />

      <div className="industry-detail">
        <p className="industry-desc">{description}</p>

        <div className="feature-grid">
          {features.map((f) => (
            <div className="feature-card" key={f.title}>
              <span className="feature-tag" style={{ color: accentColor, background: `${accentColor}15` }}>
                {f.tag}
              </span>
              <h3>{f.title}</h3>
              <p>{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default IndustryDetail;
